
const Navbar = () => {

    return <>
        <div style={{height:'69px'}} className="bg-primary w-full centers border-b border-gray-200" >
            <img className="h-10" src="https://themonopolitan.com/assets/img/logo/themonopolitan.svg" alt="" />
        </div>
    </>
}
export default Navbar